import { useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RequiredAppPermissionsList, ConditionallyRequiredAppPermissionsList, RemovedAppPermissionsList, OptionalAppPermissionsList } from '../dataPermissions/AppPermissionsList';
import { ContainerTemplate } from './ContainerTemplate';
import { useDataPermissions } from '../../contexts/DataPermissionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const appConfigPermissions = permissions => permissions.filter(permission => permission.isOnAppConfig);
export function DataPermissions({
  requiredAppPermissions,
  conditionallyRequiredAppPermissions,
  optionalAppPermissions,
  permissionsNotOnAppConfig = []
}) {
  const {
    updatedOptionalPermissions,
    setUpdatedOptionalPermissions,
    updatedConditionallyRequiredPermissions,
    setUpdatedConditionallyRequiredPermissions
  } = useDataPermissions();
  const filteredRequiredPermissions = useMemo(() => appConfigPermissions(requiredAppPermissions), [requiredAppPermissions]);
  const filteredConditionallyRequiredPermissions = useMemo(() => appConfigPermissions(conditionallyRequiredAppPermissions), [conditionallyRequiredAppPermissions]);
  const filteredOptionalPermissions = useMemo(() => appConfigPermissions(optionalAppPermissions), [optionalAppPermissions]);
  return /*#__PURE__*/_jsx(ContainerTemplate, {
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.dataPermissions.description"
    }),
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "600",
      children: [/*#__PURE__*/_jsx(RemovedAppPermissionsList, {
        permissions: permissionsNotOnAppConfig
      }), /*#__PURE__*/_jsx(RequiredAppPermissionsList, {
        permissions: filteredRequiredPermissions
      }), /*#__PURE__*/_jsx(ConditionallyRequiredAppPermissionsList, {
        changedPermissions: updatedConditionallyRequiredPermissions,
        setChangedPermissions: setUpdatedConditionallyRequiredPermissions,
        permissions: filteredConditionallyRequiredPermissions
      }), /*#__PURE__*/_jsx(OptionalAppPermissionsList, {
        changedPermissions: updatedOptionalPermissions,
        setChangedPermissions: setUpdatedOptionalPermissions,
        permissions: filteredOptionalPermissions
      })]
    })
  });
}